var React = require('react');

function Monitor (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.6667 15V16.6667L13.3333 17.5V18.3333H6.66666L6.66333 17.5033L8.33333 16.6667V15H2.49333C2.3839 14.9993 2.27567 14.9771 2.17486 14.9345C2.07404 14.892 1.98262 14.83 1.90582 14.752C1.82902 14.674 1.76837 14.5817 1.72733 14.4802C1.68629 14.3788 1.66567 14.2703 1.66666 14.1608V3.33917C1.66666 2.87583 2.04583 2.5 2.49333 2.5H17.5067C17.9633 2.5 18.3333 2.87417 18.3333 3.33917V14.1608C18.3333 14.6242 17.9542 15 17.5067 15H11.6667ZM3.33333 4.16667V13.3333H16.6666L16.6667 4.16667H3.33333Z","fill":"#0071CE"}));
}

Monitor.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Monitor;

Monitor.default = Monitor;
